import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClient } from '@angular/common/http';
import { EntityItemModule } from '../entity.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { ActivityEntityName, BulkActionType, Entity, SecurityModuleName } from '@jms/model';

@Component({
  selector: 'bulk-action-mapping-picker',
  templateUrl: './bulk.action.mapping.picker.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    EntityItemModule
  ],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: BulkImportMappingPickerComponent, multi: true }
  ]
})
export class BulkImportMappingPickerComponent extends PickerBaseComponent implements OnInit, OnChanges {

  @Input() public data: Entity[];
  @Input() public placeholder = '<Mapping>';
  @Input() public type: BulkActionType;
  @Input() public module: SecurityModuleName;
  @Input() public entity: ActivityEntityName;

  public data$: Observable<Entity[]>;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges(changes: SimpleChanges) {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.getMappings()
      : of(this.data);

  }

  private getMappings(): Observable<Entity[]> {
    return this.http.get<Entity[]>(`/api/bulk/actions/mapping/${this.type}/${this.module}/${this.entity}`);
  }


}
